import numeral from 'numeral'
import PropTypes from 'prop-types'
import React from 'react'
// load a language
numeral.language('it', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },

  currency: {
    symbol: '€',
  },
})

const FenancementDetails = ({
  numero_rate,
  importo_rata,
  tan,
  taeg,
  importo_finanziato,
  spese_istruttoria,
  spese_incasso_rata,
  oneri_fiscali_bollo,
  oneri_fiscali_bollo_comunicazione,
  importo_totale_consumatore,
  spese_invio_cartaceo,
  importo_minimo,
  importo_massimo,
  data_inizio,
  data_fine,
  intermediario,
  documentazione,
  posticipo_prima_rata,
  durata_contratto,
}) => {
  const inizio = new Date(data_inizio)
  const fine = new Date(data_fine)
  const inizio_anno = `${inizio.getFullYear()}`.substr(-2)
  const fine_anno = `${inizio.getFullYear()}`.substr(-2)
  numeral.language('it')
  numeral.defaultFormat('$ 0,0.00')

  return (
    <div>
      <p>
        Messaggio pubblicitario con finalità promozionale. Offerta valida dal{' '}
        {`${inizio.getDate()}/${inizio.getMonth() + 1}/${inizio_anno}`}
        &nbsp;al {`${fine.getDate()}/${fine.getMonth() + 1}/${fine_anno}`}.
        Importo finanziabile da {numeral(importo_minimo).format()} a{' '}
        {numeral(importo_massimo).format()}. Esempio rappresentativo riferito
        alle condizioni promozionali di campagna: importo totale del credito{' '}
        {numeral(importo_finanziato).format()}. Importo totale dovuto dal
        consumatore {numeral(importo_totale_consumatore).format()} con modalità
        di rimborso con addebito diretto in conto (SDD). {numero_rate} rate
        mensili da {numeral(importo_rata).format()}. Decorrenza 1° rata{' '}
        {posticipo_prima_rata} gg. Durata contratto {durata_contratto} mesi.
        TAEG {numeral(taeg / 100).format('0.00%')} inclusivo di: interessi al
        TAN Fisso {numeral(tan / 100).format('0.00%')}, spese di istruttoria
        pari a {numeral(spese_istruttoria).format()}, spese di incasso e
        gestione pratica pari a {numeral(spese_incasso_rata).format()} a rata;
        oneri fiscali applicati al contratto{' '}
        {numeral(oneri_fiscali_bollo).format()}; oneri fiscali applicati alle
        comunicazioni periodiche di trasparenza - min. l volta l'anno -{' '}
        {numeral(oneri_fiscali_bollo_comunicazione).format()}; spese di invio
        cartaceo comunicazione periodica trasparenza{' '}
        {numeral(spese_invio_cartaceo).format()} cad. Durata totale del
        finanziamento: {numero_rate} mesi. Per le condizioni economiche e
        contrattuali si rimanda ai documenti informativi disponibili presso{' '}
        {documentazione}. Salvo approvazione della richiesta di finanziamento da
        parte di Compass Banca S.p.A. {intermediario} opera in qualità di
        intermediario del credito in virtù del rapporto di collaborazione senza
        vincoli di esclusiva con Compass Banca S.p.A.
      </p>
      <p>
        Visualizza la{' '}
        <a
          href="https://www.compass.it/share/pdfs/COM282.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
          rel="noreferrer"
          target="_blank"
        >
          Copia contrattuale idonea per la stipula
        </a>
        , la{' '}
        <a
          href="https://www.compass.it/share/pdfs/Guida_ABF.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
          rel="noreferrer"
          target="_blank"
        >
          Guida all'Arbitro Bancario Finanziario
        </a>{' '}
        e la{' '}
        <a
          href="https://www.compass.it/share/pdfs/guida%20credito_compass.pdf#scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"
          rel="noreferrer"
          target="_blank"
        >
          Guida "Il credito ai consumatori in parole semplici"
        </a>
        .
      </p>
    </div>
  )
}

FenancementDetails.propTypes = {
  numero_rate: PropTypes.number.isRequired,
  importo_rata: PropTypes.number.isRequired,
  tan: PropTypes.number.isRequired,
  taeg: PropTypes.number.isRequired,
  finanziato_lordo: PropTypes.number.isRequired,
  importo_finanziato: PropTypes.number.isRequired,
  anticipo: PropTypes.number.isRequired,
  spese_istruttoria: PropTypes.number.isRequired,
  spese_incasso_rata: PropTypes.number.isRequired,
  oneri_fiscali_bollo: PropTypes.number.isRequired,
  oneri_fiscali_bollo_comunicazione: PropTypes.number.isRequired,
  importo_totale_consumatore: PropTypes.number.isRequired,
  spese_invio_cartaceo: PropTypes.number.isRequired,
  importo_minimo: PropTypes.number.isRequired,
  importo_massimo: PropTypes.number.isRequired,
  data_inizio: PropTypes.string.isRequired,
  data_fine: PropTypes.string.isRequired,
  intermediario: PropTypes.string.isRequired,
  documentazione: PropTypes.string.isRequired,
  posticipo_prima_rata: PropTypes.number.isRequired,
  durata_contratto: PropTypes.number.isRequired,
}

export default FenancementDetails
